export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOG02.8c7a13fe.mp3";